module.exports = __webpack_public_path__ + "img/pic_tltw_lxfsy_selected@2x.a660dfcc.png";